import { atom, } from 'recoil';
const ToastMessageAtom = atom({
    key: 'toastMessage', 
    default: '', 
    type: 'success'
});

export default ToastMessageAtom;